//sign map
//map/Map.js
import React from "react";
//import "./styles.css";

import GoogleMap from "google-map-react";
//import MCircle from "./marker/Circle";
import Pointer from "./marker/Pointer";



export default function Map(props) {
	const {signs, width, height, onClick, className, pointerColor} = props;
	const [size, setSize] = React.useState({
		width: 250,
		height:230
	});
	const [center, setCenter] = React.useState({
		lat:33.862532, 
		lng: -117.802847
	});
	const [gmap, setGmap] = React.useState({});
	const[points, setPoints] = React.useState([]);
	const [loaded, setLoaded] = React.useState(false);
	const extractLatLng = (sign) => {
		let [lng, lat] = sign?.geo_location?.split(',')?.map(n => parseFloat(n.trim()));
		if(lat && !isNaN(lat)) return {lat, lng};
		return { lat: 0, lng: 0 }
	};
	
	const validate = (sign) => {
		if(sign.geo_location){
			if(sign.geo_location.split(',').length > 1)
				return true;
		}
		return false;
	}
	
	const loadMap = (map, maps) => {
		setGmap(map);
		//setGmaps(maps);
		setLoaded(true);
	}
	//refresh on prop updates
	React.useEffect(() => {
		var spoints = [];
		if(signs){
			spoints = signs.filter(validate);
			if(spoints.length > 0){
				setPoints(spoints);
				setCenter(extractLatLng(spoints[0]));
			}
		}
		console.log(spoints);
		var newSize = Object.assign({}, size);
		if(width){
			newSize.width = width;
		}
		if(height){
			newSize.height = height;
		}
		setSize(newSize);
		
	   // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	React.useEffect(() => {
		if(loaded)
		gmap.panTo(center);
	}, [center, gmap, loaded])
  return (
	  <div style={{height: '100%', width: '100%', minHeight:200, minWidth:50}} className={className}>
      <GoogleMap
        bootstrapURLKeys={{
          // remove the key if you want to fork
          key: process.env.REACT_APP_MAP_API_KEY,
          language: "en",
          region: "US",
		  libraries: ['places'],
        }}
		yesIWantToUseGoogleMapApiInternals
        defaultCenter={{
			lat:33.862532, 
			lng: -117.802847
		}}
        defaultZoom={12}
	  	onGoogleApiLoaded={({map, maps}) => loadMap(map, maps)}
      >
        {points.map((sign) => {
	  		let cord = extractLatLng(sign);
			let color = "#05F";
			if(typeof pointerColor === 'function') color = pointerColor(sign);
          return (
            <Pointer key={sign.id} id={sign.id} lat={cord.lat} lng={cord.lng} text={sign.id} tooltip={sign.location} color={color} onClick={onClick} />
          );
        })}
      </GoogleMap>
	</div>
  );
}
